var _text, _text2, _text3, _text4, _rect, _line, _line2, _line3, _line4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCounter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Add counter function block") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    font: "18px sans-serif",
    fontWeight: "bold",
    x: 24,
    y: 42,
    dominantBaseline: "middle",
    textAnchor: "middle",
    opacity: 0.8
  }, "\r\n        0\r\n    ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    font: "18px sans-serif",
    fontWeight: "bold",
    x: 40,
    y: 42,
    dominantBaseline: "middle",
    textAnchor: "middle",
    opacity: 0.8
  }, "\r\n        0\r\n    ")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    font: "18px sans-serif",
    fontWeight: "bold",
    x: 56,
    y: 34,
    dominantBaseline: "middle",
    textAnchor: "middle",
    opacity: 0.8
  }, "\r\n        6\r\n    ")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    font: "18px sans-serif",
    fontWeight: "bold",
    x: 56,
    y: 50,
    dominantBaseline: "middle",
    textAnchor: "middle",
    opacity: 0.8
  }, "\r\n        7\r\n    ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 24,
    width: 52,
    height: 32,
    fillOpacity: 0,
    stroke: "#000",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    x2: 32,
    y1: 24,
    y2: 56,
    opacity: 0.8,
    stroke: "#000",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    x2: 48,
    y1: 24,
    y2: 56,
    opacity: 0.8,
    stroke: "#000",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 40,
    x2: 14,
    y2: 40,
    stroke: "#000",
    strokeWidth: 8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 40,
    x2: 80,
    y2: 40,
    stroke: "#000",
    strokeWidth: 8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounter);
export default __webpack_public_path__ + "static/media/counter.5f11b0a63e4dd9d0bb3a9def01ec05cd.svg";
export { ForwardRef as ReactComponent };